module.exports = __webpack_public_path__ + "img/Favicon-blanc-rvb-ubiflow-2026.ebfc1e24.svg";